interface PaymentFields {
  paymentStatus?: string | null
  molliePaymentId?: string | null
  paymentCompletedAt?: string | null
  campPrice?: number | null
  liftTicketPrice?: number | null
}

/**
 * The registration marks itself "paid" when nothing is billable, e.g. a free camp whose
 * lift ticket has no price. That is not a payment, so the admin should not read "Bezahlt".
 * A manually marked bank transfer still has a price and keeps its "Bezahlt".
 */
export const isNothingToPay = (registration: PaymentFields): boolean =>
  registration.paymentStatus === 'paid' &&
  !registration.molliePaymentId &&
  !registration.paymentCompletedAt &&
  !(Number(registration.campPrice) > 0) &&
  !(Number(registration.liftTicketPrice) > 0)
